import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AccordionComponent } from './accordion/accordion.component';
import { Testimonial2Component } from '../../testimonials/testimonial2.component';
import { InstallSharedModule } from '../../../shared/install_shared.module';
import { AccordionItemComponent } from './accordion/accordion_item.component';
import { ShopifyAddJavascriptComponent } from './content/shopify/shopify_add_javascript.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { InstallReviewsWidgetComponent } from './content/shopify/install_reviews_widget.component';
import { InstallConversionTrackingComponent } from './content/shopify/install_conversion_tracking.component';
import DynamicComponent from './accordion/default.component';
import { WooAddJavascriptComponent } from './content/woocommerce/woo_add_javascript.component';
import { WooActivatePluginComponent, } from './content/woocommerce/woo_activate_plugin.component';
import { WooSetupComponent } from './content/woocommerce/woo_setup.component';
import { BigcommerceInstallAppComponent } from './content/bigcommerce/bigcommerce_install_app.component';
import { BigcommerceBuiltinReviewsComponent } from './content/bigcommerce/bigcommerce_builtin_reviews.component';
import { BigcommerceInstallWidgetComponent } from './content/bigcommerce/bigcommerce_install_widget.component';
import { BigcommerceInstallTrackingComponent } from './content/bigcommerce/bigcommerce_install_tracking.component';
import { Magento1DisableCompilationComponent } from './content/magento1/magento1_disable_compilation.component';
import { Magento1InstallYotpoWidgetComponent } from './content/magento1/magento1_install_yotpo_widget.component';
import { Magento1InstallExtensionComponent } from './content/magento1/magento1_install_extension.component';
import { Magento1LoadPastPurchasesComponent } from './content/magento1/magento1_load_past_purchases.component';
import { Magento1DisableBuiltinReviewsComponent } from './content/magento1/magento1_disable_builtin_reviews.component';
import { Magento1ReenableCompilationComponent } from './content/magento1/magento1_reenable_compilation.component';
import { Magento2EnableYotpoModuleComponent } from './content/magento2/magento2_enable_yotpo_module.component';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
  imports: [
    CommonModule,
    PopoverModule.forRoot(),
    InstallSharedModule,
    ClipboardModule
  ],
  declarations: [
    AccordionComponent,
    AccordionItemComponent,
    ShopifyAddJavascriptComponent,
    InstallReviewsWidgetComponent,
    InstallConversionTrackingComponent,
    WooAddJavascriptComponent,
    WooActivatePluginComponent,
    WooSetupComponent,
    BigcommerceBuiltinReviewsComponent,
    BigcommerceInstallAppComponent,
    BigcommerceInstallWidgetComponent,
    BigcommerceInstallTrackingComponent,
    Magento1DisableCompilationComponent,
    Magento1InstallExtensionComponent,
    Magento1InstallYotpoWidgetComponent,
    Magento1LoadPastPurchasesComponent,
    Magento1DisableBuiltinReviewsComponent,
    Magento1ReenableCompilationComponent,
    Magento2EnableYotpoModuleComponent,
    DynamicComponent,
    Testimonial2Component
  ],
  providers: [
    TranslateService
  ]
})
export class ManualSetupModule {};
